<template>
  <v-card color="blue-grey darken-1" dark>
    <v-form>
      <v-container>
        <v-layout wrap>
          <v-flex xs12>
            <v-autocomplete
              v-model="ucs"
              :disabled="isUpdating"
              :items="consumerUnits"
              box
              chips
              color="blue-grey lighten-2"
              label="Unidade Consumidora"
              item-text="id"
              item-value="id"
              multiple
              return-object
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="remove(data.item)"
                >
                  <!-- <v-avatar>
                    <img :src="data.item.avatar">
                  </v-avatar> -->
                  {{ data.item.id }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <!-- <v-list-tile-avatar>
                    <img :src="data.item.avatar">
                  </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="data.item.id"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.address.address"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState("cs", ["consumerUnit"]),
    ...mapGetters("cs", ["consumerUnits"]),
  },
  created() {
    this.ucs = this.consumerUnits;
  },
  data() {
    // const srcs = {
    //   1: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
    //   2: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
    //   3: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
    //   4: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
    //   5: 'https://cdn.vuetifyjs.com/images/lists/5.jpg'
    // }

    return {
      autoUpdate: true,
      data: {},
      ucs: [],
      // consumerUnit: {},
      isUpdating: false,
    };
  },

  watch: {
    ucs(val) {
      this.setConsumerUnitsOpened(val);
    },
    // isUpdating (val) {
    //   console.log('val: ', val)
    //   if (val) {
    //     console.log('val: ', val)
    //     setTimeout(() =>
    //       {
    //         console.log('val: ', val)
    //         this.isUpdating = false
    //       }
    //     , 3000)
    //   }
    // }
  },

  methods: {
    ...mapMutations("cs", ["setConsumerUnitsOpened"]),
    remove(item) {
      const index = this.ucs.indexOf(item.name);
      if (index >= 0) {
        this.ucs.splice(index, 1);
        this.setConsumerUnitsOpened(this.ucs);
      }
    },
  },
};
</script>
